import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query distributionSubcategoryCreatedUpdatedById($id: MongoID!) {
    cat {
      distributionSubcategory {
        byId(_id: $id) {
          _id
          _createdBy {
            name
          }
          _updatedBy {
            name
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type DistributionSubcategoryCreatedUpdatedById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useDistributionSubcategoryCreatedUpdatedById = (id: string): DistributionSubcategoryCreatedUpdatedById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distributionSubcategory = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distributionSubcategory
}

export { useDistributionSubcategoryCreatedUpdatedById, document as distributionSubcategoryCreatedUpdatedByIdDocument }
